import { render, staticRenderFns } from "./SearchAdminButton.vue?vue&type=template&id=d074dc58&"
import script from "./SearchAdminButton.vue?vue&type=script&lang=js&"
export * from "./SearchAdminButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports